// removed by extract-text-webpack-plugin
module.exports = {"logo":"cf_v","inverseLogo":"cf_cg cf_v"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Logo/styles.module.css
// module id = 1056
// module chunks = 27